export const TOGGLE_NOTIFICATION = 'parcel/layout/TOGGLE_NOTIFICATION';
export const TOGGLE_PEOPLE_DETAILS = 'parcel/layout/TOGGLE_PEOPLE_DETAILS';
export const SET_PEOPLE_DETAILS = 'parcel/layout/SET_PEOPLE_DETAILS';
export const TOGGLE_SAFE_DETAILS = 'parcel/layout/TOGGLE_SAFE_DETAILS';
